import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { RefreshCw } from 'lucide-react';
import { epochSecondsToDate } from '@/util/formatting';

dayjs.extend(relativeTime);

interface Props {
  pmsSource: string | null | undefined;
  lastSynced: number | null | undefined; // epoch SECONDS from PropertyEntity.updatedAt
}

export function SyncManagedBanner({ pmsSource, lastSynced }: Props) {
  const vendorLabel = pmsSource && pmsSource.trim().length > 0 ? pmsSource : 'PMS';
  // lastSynced is the property's updatedAt — its last-modified time. For a
  // sync-managed (read-only) property only a PMS sync mutates it, so this is
  // effectively sync recency, but we label it honestly as "Last updated"
  // rather than overstating it as a literal sync timestamp. The vendor is
  // already named in the heading, so no need to repeat it here.
  const syncedDate = epochSecondsToDate(lastSynced);
  const syncedText = syncedDate
    ? `Last updated ${dayjs(syncedDate).fromNow()}`
    : 'Last updated time unavailable';

  return (
    <div
      className="flex items-start gap-3 rounded-lg border border-border bg-muted/40 px-4 py-3"
      role="status"
    >
      <RefreshCw className="h-5 w-5 mt-0.5 shrink-0 text-muted-foreground" aria-hidden="true" />
      <div className="text-sm">
        <div className="font-medium text-foreground">Sync-managed from {vendorLabel}</div>
        <div className="text-muted-foreground">{syncedText}. All fields are read-only.</div>
      </div>
    </div>
  );
}
